export default __webpack_public_path__ + "static/media/fillPatternFilled.40a23c08.svg";